(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-catalog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-cc-columns]');
  if (!button) return;
  var catalog = button.closest('.cc-catalog');
  catalog.querySelector('.cc-product-grid').dataset.columns = button.dataset.ccColumns;
  catalog.querySelectorAll('[data-cc-columns]').forEach(function(control) {
    control.setAttribute('aria-pressed', String(control === button));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-campar"] && !Shopify.designMode) return;
  try {
    
function initCuttleAnnouncements() {
  document.querySelectorAll('[data-cc-announcements]').forEach(function(bar) {
    if (bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = bar.querySelectorAll('[data-cc-announcement]');
    var button = bar.querySelector('button');
    var active = 0;
    items[1].hidden = true;
    button.hidden = false;
    button.addEventListener('click', function() {
      var paused = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Resume announcements' : 'Pause announcements');
      button.textContent = paused ? '▷' : 'Ⅱ';
    });
    var timer = window.setInterval(function() {
      if (!bar.isConnected) { window.clearInterval(timer); return; }
      if (document.hidden || bar.matches(':hover, :focus-within') || button.getAttribute('aria-pressed') === 'true') return;
      items[active].hidden = true;
      active = (active + 1) % items.length;
      items[active].hidden = false;
    }, 5000);
  });
}
initCuttleAnnouncements();
document.addEventListener('shopify:section:load', initCuttleAnnouncements);

  } catch(e) { console.error(e); }
})();
})();
